import { optionalRouteSearchString } from "../../shared/web/route-search.ts";
import type { GateMode } from "../contracts.ts";

export type GateScopeFilter = "team" | "project";

export type GatesSearch = {
  search?: string;
  team?: string;
  mode?: GateMode;
  scope?: GateScopeFilter;
  validation?: string;
};

export const gatesSearch = (search: Record<string, unknown>): GatesSearch => {
  const query = optionalRouteSearchString(search.search);
  const team = optionalRouteSearchString(search.team);
  const mode = search.mode === "off" || search.mode === "observe" || search.mode === "enforce" ? search.mode : undefined;
  const scope = search.scope === "team" || search.scope === "project" ? search.scope : undefined;
  const validation = optionalRouteSearchString(search.validation);

  return {
    ...(query ? { search: query } : {}),
    ...(team ? { team } : {}),
    ...(mode ? { mode } : {}),
    ...(scope ? { scope } : {}),
    ...(validation ? { validation } : {}),
  };
};
